import { CountryCode } from "../../../../helpers";
import classes from "./style.module.scss";
import dayjs from 'dayjs';

const CustomerInformation = (props) => {
  const { notoficationInfo } = props;
  const formattedTime = notoficationInfo?.scheduled_time
  ? dayjs(notoficationInfo.scheduled_time, 'HH:mm').format('hh:mm A')
  : '-'; 
  return (
    <>
      <div className={`${classes.notifyCardWrapper} mb-4`}>
        <div className={`${classes.detailsWrapper}`}>
          <div className="flex items-center mb-4">
            <div
              className={`${classes.informationHeader} flex items-center !mb-0 fs-20 `}
            >
              Customer Details
            </div>
          </div>
          <div className={`${classes.infoWrapper}`}>
            <div className={`${classes.inforCategory}`}>
              <div className={`${classes.infoLabel}`}>User type</div>
              <div className={`${classes.infoValue}`}>
                {notoficationInfo?.type === 1
                  ? "GENERAL"
                  : notoficationInfo?.type === 2
                  ? "PROMOTIONAL"
                  : "ALERT"}
              </div>
            </div>
            <div className={`${classes.inforCategory}`}>
              <div className={`${classes.infoLabel}`}>ID</div>
              <div className={`${classes.infoValue}`}>
                {notoficationInfo?.notification_id}
              </div>
            </div>
            <div className={`${classes.inforCategory}`}>
              <div className={`${classes.infoLabel}`}>Receipent</div>
              <div className={`${classes.infoValue}`}>
                {notoficationInfo?.recipient === 1
                  ? "RETAILER"
                  : notoficationInfo?.recipient === 2
                  ? "MECHANICS"
                  : "BOTH"}
              </div>
            </div>
            <div className={`${classes.inforCategory}`}>
              <div className={`${classes.infoLabel}`}>Country</div>
              <div className={`${classes.infoValue}`}>
                  {CountryCode[notoficationInfo?.country_id]}
              </div>
            </div>
            <div className={`${classes.inforCategory}`}>
              <div className={`${classes.infoLabel}`}>Scheduled Date</div>
              <div className={`${classes.infoValue}`}>
                  {notoficationInfo?.scheduled_date || "-"}
              </div>
            </div>
            <div className={`${classes.inforCategory}`}>
              <div className={`${classes.infoLabel}`}>Scheduled Time</div>
              <div className={`${classes.infoValue}`}>
                  {formattedTime}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerInformation;
